export interface IBodyAssessment {
    pickUpMassEasily: pickUpMassEasilyAnswer;
    shouldersWiderThanHips: shouldersWiderThanHipsAnswer;
    wristEncircle: wristEncircleAnswer;
    athleteMode: athleteAnswer;

    weightPattern: weightPatternAnswer;
    bodyShape: bodyShapeAnswer;
}

export enum athleteAnswer {
    no = 'no',
    isConditionedAthlete = 'isConditionedAthlete',
}

export enum weightPatternAnswer {
    troubleGainingWeight = 'troubleGainingWeight',
    gainAndLoseWeightEasy = 'gainAndLoseWeightEasy',
    gainWeightEasyLosingHard = 'gainWeightEasyLosingHard',
}

export enum pickUpMassEasilyAnswer {
    yesMuscle = 'yesMuscle',
    yesFat = 'yesFat',
    yesMuscleAndFat = 'yesMuscleAndFat',
    no = 'no',
}

export enum bodyShapeAnswer {
    pencil = 'pencil',
    hourGlass = 'hourGlass',
    appleOrPear = 'appleOrPear',
}

export enum shouldersWiderThanHipsAnswer {
    yes = 'yes',
    noHipsWider = 'noHipsWider',
    noHipsSame = 'noHipsSame',
}

export enum wristEncircleAnswer {
    notTouch = 'notTouch',
    justTouch = 'justTouch',
    overlap = 'overlap',
}

export enum bodyComposition {
    meso,
    endo_meso,
    ecto_meso,
    endo,
    ecto,
}
